module.exports = __webpack_public_path__ + "img/hover_icon_sr-weeks-configuration.5c792c38.svg";